export default __webpack_public_path__ + "static/media/deliland-gcoil-icon.99f9c11c.png";